var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',[_vm._t("default")],2):_c('div',[_c('input',{attrs:{"type":"hidden","name":_vm.hiddenInputName,"value":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }